/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/28/2023
 */
import React, { useEffect, useState } from "react";
import ApprovedRoleItem from "./ApprovedRoleItem";
import {
  Stack,
  LinearProgress,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material"
import api from "../../services/AuthApi";
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling";
import Alerts from "../../errorHandeling/Alerts";
import SearchIcon from "@mui/icons-material/Search"


const ApprovedRoles = ({ data, setIsPendingChange, isPendingChange }) => {
  const [approvedData, setApprovedData] = useState([]);
  const [filterData, setfilterData] = useState([])
  const [apprLoading, setApprDataLoading] = useState(true);

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [iserrorShow, setIserrorShow] = useState(false);
  const [isUnauhtError, setIsUnauhtError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  let apprvConfig = {
    headers: {
      Action: "VAPR",
      "Sort-Field": "roleId",
    },
  };

  useEffect(() => {
    setApprDataLoading(true);
    setIsPendingChange(false);
    api
      .get("/role/permissions", apprvConfig)
      .then((res) => {
        setApprovedData(res.data?.dataList[0].rolePerms);
        setfilterData(res.data?.dataList[0].rolePerms)
        setApprDataLoading(false);
        setErrorMessages([]);
        setIserror(false);
        setIsUnauhtError(false);
      })
      .catch((error) => {
        console.log(error);
        setApprDataLoading(false);
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        );
      });
  }, [isPendingChange, isUnauhtError]);

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false);
        setSuccessMessages([]);
      }, 3000);
    }
  }, [isSuccess]);

  const searchFilter = (e) => {
    const searchVal = e.target.value
    const results = approvedData.filter((roleData) => {
      return roleData.role.toLowerCase().includes(searchVal.toLowerCase())
    })
    setfilterData(results)
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Role"
          inputProps={{ "aria-label": "search role" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {apprLoading ? (
        <div>
          <LinearProgress />
        </div>
      ) : (
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          {filterData.map((d, i) => {
            return (
              <ApprovedRoleItem
                key={d?.role}
                roleTitle={d?.role}
                level={d?.level}
                desc={d?.desc}
                perms={d?.permissions}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
                setIsPendingChange={setIsPendingChange}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
};
export default ApprovedRoles;
